// extracted by mini-css-extract-plugin
export default {"title":"require-team-owner_title__J5OBX","card":"require-team-owner_card__9STTN","text":"require-team-owner_text__cQVdX","button":"require-team-owner_button__sztcT"};